import { useState } from "react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { X } from "@phosphor-icons/react";

const ROLE_TAGS = ["all", "server", "bartender", "barista", "line_cook", "housekeeping"];

export const VideoEditModal = ({ video, onClose, onSaved }) => {
  const [form, setForm] = useState({
    title: video.title, description: video.description || "",
    role_tag: video.role_tag || "all", category: video.category || "Training",
  });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!form.title.trim()) return toast.error("Title is required");
    setBusy(true);
    try {
      const { data } = await api.put(`/videos/${video.id}`, form);
      toast.success("Video updated");
      onSaved(data);
      onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[1000] bg-slate-950/50 flex items-center justify-center p-4 sm:p-6" onClick={onClose}>
      <div data-testid="video-edit-modal" onClick={(e) => e.stopPropagation()} className="bg-white w-full sm:max-w-lg max-h-[90vh] overflow-y-auto rounded-3xl p-6 sm:p-8 rise-in">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-2xl font-bold">Edit video</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 tap-press"><X size={24} /></button>
        </div>
        <div className="space-y-4">
          <input data-testid="video-edit-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder="Title" className="w-full h-12 px-4 rounded-xl border border-slate-200" />
          <textarea data-testid="video-edit-description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
            rows={3} placeholder="Description" className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm" />
          <div className="grid grid-cols-2 gap-4">
            <select data-testid="video-edit-role" value={form.role_tag} onChange={(e) => setForm({ ...form, role_tag: e.target.value })}
              className="h-12 px-4 rounded-xl border border-slate-200 bg-white font-semibold capitalize">
              {ROLE_TAGS.map((r) => <option key={r} value={r}>{r.replace("_", " ")}</option>)}
            </select>
            <input data-testid="video-edit-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
              placeholder="Category" className="h-12 px-4 rounded-xl border border-slate-200" />
          </div>
          <button data-testid="video-edit-save" onClick={save} disabled={busy}
            className="w-full h-14 rounded-full bg-slate-900 text-white font-heading font-bold tap-press hover:bg-slate-800 disabled:opacity-50">
            {busy ? "Saving…" : "Save changes"}
          </button>
        </div>
      </div>
    </div>
  );
};
